<template>
  <transition name="slide-fade">
    <div class="toast cut-border" v-show="visible">
      <div class="cut-border__inner">
        <p class="text">{{ message }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'toast',
  data () {
    return {
      message: '', // 消息文字
      duration: 1500, // 显示时长，毫秒
      closed: false, // 用来判断消息框是否关闭
      timer: null, // 计时器
      visible: false // 是否显示
    }
  },
  mounted () {
    this.startTimer()
  },
  watch: {
    closed (newVal) {
      if (newVal) {
        this.visible = false
        this.destroyElement()
      }
    }
  },
  methods: {
    destroyElement () {
      this.$destroy()
      this.$el.parentNode.removeChild(this.$el)
    },
    startTimer () {
      this.timer = setTimeout(() => {
        if (!this.closed) {
          this.closed = true
          clearTimeout(this.timer)
        }
      }, this.duration)
    }
  }
}
</script>

<style lang="scss">
.toast {
  position: fixed;
  top: 40%;
  left: 50%;
  text-align: center; 
  font-size: 24px;
  color: #fff6bb;
  transform: translate(-50%,-50%);
  z-index: 10000;
}

.cut-border{
  --cut: 12px;    /* 切角大小 */
  --border: 1px;  /* 边框宽度 */
  min-width: 462px;
  height: 65px;
  line-height: 65px;
  background: #7c9066;
  /* -webkit-clip-path: polygon(12px 0, calc(100% - 12px) 0, 100% 12px, 100% calc(100% - 12px), calc(100% - 12px) 100%, 12px 100%, 0 calc(100% - 12px), 0 12px);
  clip-path: polygon(12px 0, calc(100% - 12px) 0, 100% 12px, 100% calc(100% - 12px), calc(100% - 12px) 100%, 12px 100%, 0 calc(100% - 12px), 0 12px); */
}

.cut-border__inner{
  inset: var(--border);
  width: calc(100% - var(--border) * 2);
  height: 63px;
  background: #3d5f3a; /* 填充色 */
  /* -webkit-clip-path: polygon(12px 0, calc(100% - 12px) 0, 100% 12px, 100% calc(100% - 12px), calc(100% - 12px) 100%, 12px 100%, 0 calc(100% - 12px), 0 12px);
  clip-path: polygon(12px 0, calc(100% - 12px) 0, 100% 12px, 100% calc(100% - 12px), calc(100% - 12px) 100%, 12px 100%, 0 calc(100% - 12px), 0 12px); */
  display:flex;
  align-items:center;
  justify-content:center;
  color: #fff6bb;
  font-size: 24px;
  line-height: 1;
}

.toast .text{ 
  padding: 0 30px;
  white-space: nowrap;
}

</style>